document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.kavosz-hero-slider').forEach((slider) => {
    const slides = slider.querySelectorAll('.kavosz-hero-slide')
    if (slides.length <= 1) return

    const dots = slider.querySelectorAll('.kavosz-slider-dot')
    const prevBtn = slider.querySelector('.kavosz-slider-prev')
    const nextBtn = slider.querySelector('.kavosz-slider-next')
    const autoplay = slider.dataset.autoplay === 'true'
    const speed = parseInt(slider.dataset.autoplaySpeed) || 5000

    let current = 0
    let timer = null

    const goTo = (index) => {
      slides[current].classList.remove('is-active')
      dots[current]?.classList.remove('is-active')
      current = (index + slides.length) % slides.length
      slides[current].classList.add('is-active')
      dots[current]?.classList.add('is-active')
    }

    prevBtn?.addEventListener('click', () => {
      goTo(current - 1)
      resetTimer()
    })

    nextBtn?.addEventListener('click', () => {
      goTo(current + 1)
      resetTimer()
    })

    // Mobil navigáció
    slider.querySelector('.kavosz-mobile-navigation .swiper-button-prev')?.addEventListener('click', () => {
      goTo(current - 1)
      resetTimer()
    })

    slider.querySelector('.kavosz-mobile-navigation .swiper-button-next')?.addEventListener('click', () => {
      goTo(current + 1)
      resetTimer()
    })

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goTo(i)
        resetTimer()
      })
    })

    const startTimer = () => {
      if (autoplay) {
        timer = setInterval(() => goTo(current + 1), speed)
      }
    }

    const resetTimer = () => {
      clearInterval(timer)
      startTimer()
    }

    startTimer()
  })
})
